import { raiseUnreachable } from '@weft/utils';
import React from 'react';
import { ContractReviseForm } from '../../contract/ContractRevisePage/ContractReviseForm';
import { ContractUpdateForm } from '../../contract/ContractUpdatePage/ContractUpdateForm';
import { CreatePlanForm } from './create-plan-page-components/CreatePlanForm/CreatePlanForm';
import { FormType } from './FormType';

export const withPlanForm = <ComponentProps extends Record<string, unknown>>(Component: React.ComponentType<ComponentProps>, formType: FormType) => {
  return (componentProps: ComponentProps) => {
    switch (formType) {
      case FormType.CreatePlanForm:
        return (
          <CreatePlanForm>
            <Component {...componentProps}/>
          </CreatePlanForm>
        );
      case FormType.UpdatePlanForm:
        return (
          <ContractUpdateForm>
            <Component {...componentProps}/>
          </ContractUpdateForm>
        );
      case FormType.ReviseContract:
        return (
          <ContractReviseForm>
            <Component {...componentProps}/>
          </ContractReviseForm>
        );
      default:
        return raiseUnreachable(formType);
    }
  };
};
